import React from 'react'
import { Link } from 'react-router-dom'
import rightArrowBlack from '../../images/right_arrow_black.png'

export type BreadcrumbItem = {
  label: string
  path?: string
}

type Props = {
  items: BreadcrumbItem[]
}

const Breadcrumb: React.FC<Props> = ({ items }) => {
  return (
    <nav className="flex flex-wrap items-center text-sm mb-6">
      {items.map((item, index) => {
        const isLast = index === items.length - 1

        return (
          <div
            key={`breadcrumb-${item.path || item.label}-${index}`}
            className="flex items-center"
          >
            {index > 0 && (
              <img
                src={rightArrowBlack}
                alt=">"
                className="w-3 h-3 mx-2 object-contain"
              />
            )}
            {isLast || !item.path ? (
              <span className="text-main-darkgray">{item.label}</span>
            ) : (
              <Link
                to={item.path}
                className="text-main-green transition-opacity duration-300 hover:opacity-50"
              >
                {item.label}
              </Link>
            )}
          </div>
        )
      })}
    </nav>
  )
}

export default Breadcrumb
